import { LoadingButton } from "@mui/lab";
import { Alert, Grid, MenuItem, TextField } from "@mui/material";
import AutoCompleteListFormik from "components/AutoCompleteListFormik";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createVideoAllocationThunk } from "store/reducers/advertisement/adsVideoAllocationSlice";
import {
  adsVideoSelector,
  getVideosThunk,
} from "store/reducers/advertisement/adsVideoSlice";
import * as yup from "yup";

const AdVidsInMachineCreate = ({ m_id }) => {
  const dispatch = useDispatch();
  const validation = yup.object({
    machine: yup.number().required("Machine required"),
    ad_location: yup.string().required("Please choose a location"),
  });
  const formik = useFormik({
    initialValues: {
      machine: m_id,
      ad_location: "front",
      video: null,
    },
    validationSchema: validation,
    onSubmit: (data) => {
      const _data = { ...data, video: data.video.id };
      // console.log(_data);
      dispatch(createVideoAllocationThunk(_data));
    },
    validateOnChange: false,
  });
  const videos = useSelector(adsVideoSelector.selectAll);
  const { loading, success, errorMessage, error } = useSelector(
    (state) => state.adsVideoAllocation
  );
  useEffect(() => {
    if (errorMessage?.create) {
      Object.keys(errorMessage.create).forEach((key) => {
        console.log(key, errorMessage.create[key][0]);
        formik.setFieldError(key, errorMessage.create[key][0]);
      });
    }
  }, [errorMessage]);
  useEffect(() => {
    dispatch(getVideosThunk());
  }, []);

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={1} paddingY={1}>
        <Grid item xs={12} md={6} lg={4}>
          <AutoCompleteListFormik
            items={videos}
            name="title"
            label="Choose video"
            formik={formik}
            formikName="video"
            required={true}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Select video location"
            variant="outlined"
            name="ad_location"
            select
            fullWidth
            value={formik.values.ad_location}
            onChange={formik.handleChange("ad_location")}
            error={Boolean(formik.errors.ad_location)}
            helperText={formik.errors.ad_location}
            autoComplete="new-password"
          >
            <MenuItem value="front">Front page</MenuItem>
            <MenuItem value="payment">Payment page</MenuItem>
            <MenuItem value="vend">Vend page</MenuItem>
          </TextField>
        </Grid>
      </Grid>

      {error?.create && (
        <Alert sx={{ my: 1 }} severity="error">
          Error occurred
        </Alert>
      )}

      {success?.create && (
        <Alert sx={{ my: 1 }} severity="success">
          Success
        </Alert>
      )}
      <LoadingButton
        loading={loading?.create}
        variant="contained"
        type="submit"
        sx={{ paddingX: 10, marginTop: 1 }}
      >
        Add video
      </LoadingButton>
    </form>
  );
};

export default AdVidsInMachineCreate;
